import { useAtomValue, useSetAtom } from 'jotai';
import { memo, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Flex, IconSvg } from '@/lib/v2/components';
import { HeaderBanner } from '@/lib/v2/examples';
import { FolderIcon, FolderToolIcon } from '@/lib/v2/icons/solid';

import { ActionButtons } from './components/ActionButtons';
import { Content } from './components/Content';
import Footer from './components/Footer/Footer';

import {
  atomDetailCampaign,
  atomLoadingDetail,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import {
  atomModalTypeProcess,
  atomScreenTypeProcess,
  atomToggleEditCreateCampaignModal,
} from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { useCampaign } from '@/modules/CampaignsModule/hooks/useCampaigns';
import {
  ECampaignsTypeOptions,
  ModalType,
  ScreenType,
} from '@/modules/CampaignsModule/interfaces/Campaigns';

const HeaderBannerActions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getDetailCampaign } = useCampaign();
  const detailCampaign = useAtomValue(atomDetailCampaign);
  const loadingDetail = useAtomValue(atomLoadingDetail);
  const setModalTypeProcess = useSetAtom(atomModalTypeProcess);
  const setScreenTypeProcess = useSetAtom(atomScreenTypeProcess);
  const setToggleEditCategoryModal = useSetAtom(atomToggleEditCreateCampaignModal);

  useEffect(() => {
    void getDetailCampaign({ campaignID: Number(id) });
  }, [getDetailCampaign, id]);

  const handleClickEditCampaign = useCallback(() => {
    setModalTypeProcess(ModalType.EDIT);
    setScreenTypeProcess(ScreenType.DETAIL);
    setToggleEditCategoryModal(true);
  }, [setModalTypeProcess, setToggleEditCategoryModal, setScreenTypeProcess]);

  return (
    <Flex column>
      <HeaderBanner
        backButton
        withFooter
        actionsButtons={<ActionButtons toggleModal={handleClickEditCampaign} />}
        content={<Content loading={!id || loadingDetail} toggleModal={handleClickEditCampaign} />}
        footerContent={<Footer />}
        icon={
          <IconSvg
            rounded
            bgColor="headingIcon"
            height="42px"
            svgComponent={
              detailCampaign.campaignTypeId === ECampaignsTypeOptions.MANUAL ? (
                <FolderIcon />
              ) : (
                <FolderToolIcon />
              )
            }
            width="42px"
            withPadding="medium"
          />
        }
        onBack={() => navigate && navigate('/v2/campaigns')}
      />
    </Flex>
  );
};

export default memo(HeaderBannerActions);
